import { render, staticRenderFns } from "./LayoutWithScrollbar.vue?vue&type=template&id=44db6f95&scoped=true&"
import script from "./LayoutWithScrollbar.vue?vue&type=script&lang=js&"
export * from "./LayoutWithScrollbar.vue?vue&type=script&lang=js&"
import style0 from "./LayoutWithScrollbar.vue?vue&type=style&index=0&id=44db6f95&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44db6f95",
  null
  
)

export default component.exports